export default __webpack_public_path__ + "static/media/essay-plain-text-blue.c49ca447.svg";